/**
 * Utility function to detect LinkedIn iOS in-app browser and redirect to Safari
 *
 * This function solves an issue where users clicking links in the LinkedIn iOS app
 * would encounter a 403 disallowed user agent error from Google authentication.
 *
 * It works by detecting the LinkedIn in-app browser on iOS and redirecting the user
 * to the same URL with the 'x-safari-' protocol, which opens the link in Safari instead.
 */
function detectLinkedInBrowser(): void {
  const url = window.location.href;
  const userAgent = window.navigator.userAgent;
  const isMobile = userAgent.includes('Mobile');
  const isLinkedInApp = userAgent.includes('LinkedInApp');
  const isIOS = userAgent.includes('iPhone') || userAgent.includes('iPad');

  if (isMobile && isIOS && isLinkedInApp) {
    window.location.href = 'x-safari-' + url;
  }
}

export default detectLinkedInBrowser;
